import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToggleSwitchButtonComponent } from './toggle-switch-button.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';



@NgModule({
  declarations: [ ToggleSwitchButtonComponent ],
  imports: [
    CommonModule,
    MatSlideToggleModule,
  ],
  exports: [
    ToggleSwitchButtonComponent
  ]
})
export class ToggleSwitchButtonModule { }
